import type { Periodicity } from 'entities/periodicity'

export const PERIODICITIES: Periodicity[] = ['daily', 'weekly', 'monthly']

export const DEFAULT_PERIODICITY: Periodicity = 'monthly'
